export interface IEventLog {
  id: string;
  type: string;
  actionType: string;
  name: string;
  email: string;
  searchableEmail: string;
  orgName: string;
  oppName: string;
  termCode: string;
  eventDate: string;
  username: string;
  linkedRecordId: string;
  additionalData: string;
  comment: string;
}

export enum EventLogEventType {
  ORGANIZATION = 'ORGANIZATION',
  OPPORTUNITY = 'OPPORTUNITY',
  SERVICE_REGISTRATION = 'SERVICE_REGISTRATION',
  SUPERVISOR = 'SUPERVISOR',
}

export enum EventLogActionType {
  CANCELED = 'CANCELED',
  CREATED = 'CREATED',
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  ACTIVATED = 'ACTIVATED',
  DENIED = 'DENIED',
  DEACTIVATED = 'DEACTIVATED',

  DROP_REQUESTED = 'DROP_REQUESTED',
  DROPPED = 'DROPPED',

  EVAL_COMPLETED = 'EVAL_COMPLETED',
  SUPERVISOR_EVAL_COMPLETED = 'SUPERVISOR_EVAL_COMPLETED',
  GRADED = 'GRADED',
  BANNER_REGISTERED = 'BANNER_REGISTERED',

  CHANGES_REQUESTED = 'CHANGES_REQUESTED',
  CHANGES_APPROVED = 'CHANGES_APPROVED',
  CHANGES_DENIED = 'CHANGES_DENIED',

  SUPERVISOR_CHANGED = 'SUPERVISOR_CHANGED',

  COMMENT = 'COMMENT'
}
